/* Regional LP behaviors: dealer-finder filtering and the mobile gallery
   auto-drift. More than one "LP — Regional" section includes this file,
   so every init is guarded by data-rlp-bound. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initDealers(root) {
    if (root.dataset.rlpBound) return;
    root.dataset.rlpBound = '1';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-region]'));
    var input = root.querySelector('[data-rlp-search]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dealer]'));
    var empty = root.querySelector('[data-rlp-empty]');
    var toggle = root.querySelector('[data-rlp-toggle]');
    var cap = parseInt((toggle && toggle.dataset.cap) || '5', 10);
    var state = { region: 'All', q: '', expanded: false };

    function apply() {
      var term = state.q.trim().toLowerCase();
      var searching = state.region !== 'All' || term.length > 0;
      var matches = cards.filter(function (card) {
        var regionOk = state.region === 'All' || card.dataset.region === state.region;
        var qOk = !term ||
          card.dataset.city.indexOf(term) !== -1 ||
          card.dataset.zip.indexOf(term) !== -1 ||
          card.dataset.name.indexOf(term) !== -1;
        return regionOk && qOk;
      });
      // Any active search or region filter always shows all matches;
      // the 5-dealer cap only applies to the unfiltered mobile list.
      var capped = MOBILE.matches && !searching && !state.expanded && matches.length > cap;
      var visible = capped ? matches.slice(0, cap) : matches;
      cards.forEach(function (card) {
        card.classList.toggle('is-hidden', visible.indexOf(card) === -1);
      });
      if (empty) empty.classList.toggle('is-visible', matches.length === 0);
      if (toggle) {
        var toggleable = MOBILE.matches && !searching && matches.length > cap;
        toggle.classList.toggle('is-visible', toggleable);
        toggle.textContent = state.expanded
          ? toggle.dataset.labelLess
          : toggle.dataset.labelMore.replace('{count}', matches.length);
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.region = chip.dataset.region;
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        apply();
      });
    });
    if (input) input.addEventListener('input', function () { state.q = input.value; apply(); });
    if (toggle) toggle.addEventListener('click', function () { state.expanded = !state.expanded; apply(); });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', apply);
    apply();
  }

  function initGallery(root) {
    if (root.dataset.rlpBound) return;
    root.dataset.rlpBound = '1';

    var expand = root.querySelector('[data-rlp-expand]');
    var more = root.querySelector('[data-rlp-more]');
    if (expand && more) {
      expand.addEventListener('click', function () {
        var open = more.classList.toggle('is-open');
        expand.textContent = open ? expand.dataset.labelLess : expand.dataset.labelMore;
      });
    }

    // Mobile auto-drift: slow scroll so users know the gallery moves,
    // ping-pong at the ends, 4s pause after any touch. Position must be
    // accumulated in a float — browsers round scrollLeft to integers, so
    // a fractional `scrollLeft += 0.35` never moves the element.
    var wrap = root.querySelector('[data-rlp-track-wrap]');
    if (!wrap) return;
    var dir = 1;
    var pos = 0;
    var pausedUntil = 0;
    var pause = function () { pausedUntil = Date.now() + 4000; };
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      wrap.addEventListener(ev, pause, { passive: true });
    });
    function tick() {
      if (MOBILE.matches && !REDUCED.matches) {
        if (Date.now() > pausedUntil) {
          var max = wrap.scrollWidth - wrap.clientWidth;
          if (max > 0) {
            // re-sync if the user scrolled while we were paused
            if (Math.abs(wrap.scrollLeft - pos) > 2) pos = wrap.scrollLeft;
            pos += 0.35 * dir;
            if (pos >= max - 1) { pos = max - 1; dir = -1; }
            else if (pos <= 1) { pos = 1; dir = 1; }
            wrap.scrollLeft = pos;
          }
        } else {
          pos = wrap.scrollLeft;
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rlp-dealers]'), initDealers);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rlp-gallery]'), initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
